import cn from 'classnames';
import { SnowUnit } from 'components/blocks/Unit';
import { formastAs24hourWeekday } from 'util/formatAgo';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { formatDateFromStr } from 'util/formatDate';
import styles from './styles.module.scss';

interface ISnowItemProps {
  snow: number,
  date: string,
  height: number,
  show24Hour?: boolean
  isMetricUnits?: boolean
}

export const SnowItemData = ({ snow, isMetricUnits } : ISnowItemProps) => (
  <td className={styles.cell}>
    <span className={cn(styles.snow, { [styles.metric]: isMetricUnits })}><SnowUnit values={snow} /></span>
  </td>
);

export const SnowItemTh = ({ date, show24Hour } :ISnowItemProps) => {
  const { t } = useOTSTranslation('common');

  return (
    <th scope="col" className={styles.cell}>
      <time dateTime={formatDateFromStr(date, 'yyyy-MM-dd')}>
        {/* <span className={styles.date}>{formatShortDateStr(date)}</span> */}
        <span className={styles.day}>{show24Hour ? formastAs24hourWeekday(date, t) : formatDateFromStr(date, 'ccc') }</span>
      </time>
    </th>
  );
};

export const SnowItemChart = ({ height }: ISnowItemProps) => (
  <td className={styles.cell}>
    <span className={styles.col}>
      <span className={styles.bar} style={{ height: `${height * 100}%` }} />
      {height === 0 && (
        <span className={styles.zero}>&nbsp;</span>
      )}
    </span>
  </td>
);
